{
  "groups": {
    "dashboard": "Vue d'ensemble",
    "work": "Travail",
    "administration": "Gestion",
    "people": "Personnel",
    "time-attendance": "Temps et présence",
    "payroll": "Paie",
    "reports": "Rapports",
    "setup": "Configuration",
    "operations": "Opérations",
    "expenses": "Dépenses et voyages",
    "talent": "Talents et performance",
    "portals": "Portails libre-service",
    "settings": "Paramètres"
  },
  "paths": {
    "hr": "RH Tableau de bord",
    "hr.attendance": "Présence et Congés",
    "hr.timesheet": "Feuille de temps",
    "hr.payroll": "Paie runs",
    "hr.dashboard": "RH Tableau de bord",
    "hr.leaves": "Congéss",
    "hr.ess": "Ess",
    "hr.mss": "Mss",
    "hr.setup": "Configuration",
    "hr.master-data": "Données de référence",
    "org.companies": "Sociétés",
    "work.approvals": "Boîte d'approbation",
    "pos.dashboard": "Tableau de bord",
    "pos.stores": "Magasins",
    "pos.products": "Produits",
    "pos.categories": "Catégories",
    "pos.brands": "Marques",
    "pos.units": "Unités",
    "pos.tax-rules": "Règles fiscales",
    "pos.store-products": "Magasins Produits",
    "pos.invoices": "Factures",
    "pos.inventory": "Inventaire",
    "pos.inventory.ledger": "Grand livre",
    "pos.product-alerts": "Produits Alerts",
    "pos.suppliers": "Fournisseurs",
    "pos.customers": "Clients",
    "pos.discounts": "Remises",
    "pos.reports": "Rapports",
    "pos.terminal-reports": "Terminal Rapports",
    "pos": "PDV",
    "pos.held": "Retenu",
    "pos.shift": "Équipes",
    "pos.returns": "Retours",
    "pos.analytics": "Analytique",
    "pos.setup": "Configuration",
    "warehouse": "Entrepôt",
    "warehouse.operations": "Opérations",
    "warehouse.mobile": "Mobile",
    "warehouse.setup": "Configuration",
    "warehouse.picks": "Prélèvements",
    "warehouse.transfers": "Transferts",
    "warehouse.cycle-counts": "Inventaires tournants",
    "warehouse.waves": "Vagues",
    "warehouse.dock": "Quai",
    "warehouse.cross-dock": "Transbordement",
    "warehouse.labor": "Main-d'œuvre",
    "procurement": "Achats",
    "procurement.purchase-requests": "Achat Requests",
    "procurement.rfqs": "Demandes de prix",
    "procurement.quotations": "Devis",
    "procurement.purchase-orders": "Achat Commandes",
    "procurement.goods-receipts": "Réceptions de marchandises",
    "procurement.vendor-bills": "Factures fournisseurs",
    "procurement.approvals": "Approbations",
    "procurement.reports": "Rapports",
    "procurement.setup": "Configuration",
    "procurement.contracts": "Contrats",
    "procurement.catalogs": "Catalogues",
    "crm": "CRM",
    "crm.leads": "Prospects",
    "crm.contacts": "Contacts",
    "crm.companies": "Sociétés",
    "crm.deals": "Affaires",
    "crm.pipelines": "Pipelines",
    "crm.followups": "Suivis",
    "crm.tasks": "Tâches",
    "crm.campaigns": "Campagnes",
    "crm.analytics": "Analytique",
    "crm.reports": "Rapports",
    "crm.setup": "Configuration",
    "lead-gen": "Génération de prospects",
    "lead-gen.forms": "Formulaires",
    "lead-gen.landing-pages": "Pages d'atterrissage",
    "lead-gen.campaigns": "Campagnes",
    "lead-gen.visitor-tracking": "Suivi des visiteurs",
    "lead-gen.scoring": "Scoring",
    "lead-gen.routing": "Routage",
    "lead-gen.ab-tests": "Tests A/B",
    "lead-gen.webhooks": "Webhooks",
    "lead-gen.enrichment": "Enrichissement",
    "lead-gen.consent": "Consentement",
    "lead-gen.reports": "Rapports",
    "lead-gen.sources": "Sources",
    "marketing": "Marketing",
    "marketing.campaigns": "Campagnes",
    "marketing.segments": "Segments",
    "marketing.journeys": "Parcours",
    "marketing.templates": "Modèles",
    "marketing.lifecycle": "Cycle de vie",
    "marketing.reports": "Rapports",
    "marketing.webhooks": "Webhooks",
    "social": "Social",
    "social.inbox": "Boîte de réception",
    "social.channels": "Canaux",
    "social.publishing": "Publication",
    "social.calendar": "Calendrier",
    "social.media": "Médias",
    "social.analytics": "Analytique",
    "social.automation": "Automatisation",
    "social.crm-leads": "CRM Leads",
    "social.teams": "Équipes",
    "social.comments": "Commentaires",
    "social.connect": "Connexion",
    "social.settings": "Paramètres",
    "social.platforms": "Plateformes",
    "social.approvals": "Approbations",
    "social.webhooks": "Webhooks",
    "social.listening": "Listeening",
    "social.campaigns": "Campagnes",
    "social.reviews": "Avis",
    "social.reports": "Rapports",
    "social.setup": "Configuration",
    "hr.employees": "Employés directory",
    "hr.devices": "Appareils biométriques",
    "hr.leave-policies": "Congés Politiques",
    "hr.shifts": "Équipes",
    "hr.overtime": "Heures supplémentaires requests",
    "hr.compensation": "Salary et benefits",
    "hr.statutory": "Déclarations légales",
    "hr.claims": "Dépenses claims",
    "hr.travel": "Demandes de déplacement",
    "hr.reports": "RH Analytique et Tableau de bords",
    "hr.workflows": "Flux de travails",
    "hr.recruitment": "Recrutement",
    "hr.documents": "Documents",
    "hr.succession": "Succession",
    "hr.admin": "Admin",
    "hr.training": "Formation",
    "hr.appraisal": "Évaluation",
    "hr.feedback360": "Feedback 360",
    "hr.holidays": "Jours fériés",
    "hr.loans": "Prêts",
    "hr.asset-requests": "Demandes d'actifs",
    "desk": "Service client",
    "desk.tickets": "Tickets",
    "desk.support-360": "Support 360",
    "desk.inbox": "Boîte de réception",
    "desk.livechat": "Livechat",
    "desk.projects": "Projets",
    "desk.boards": "Tableaux",
    "desk.knowledgebase": "Knowledgebase",
    "desk.reports": "Rapports",
    "desk.automation": "Automatisation",
    "desk.setup": "Configuration",
    "desk.setup.workflows": "Flux de travails",
    "desk.canned-responses": "Réponses prédéfinies",
    "finance": "Finances",
    "finance.receivables": "Receivables",
    "finance.payables": "Payables",
    "finance.payables.ap": "Ap",
    "finance.tax": "Fiscalité",
    "finance.control": "Control",
    "finance.setup.wizard": "Wizard",
    "finance.health": "Health",
    "finance.close": "Fermer",
    "finance.control.rules": "Règles",
    "finance.treasury.forecast": "Forecast",
    "finance.collections": "Collections",
    "finance.automation": "Automatisation",
    "finance.analytics": "Analytique",
    "finance.compliance": "Compliance",
    "finance.audit": "Audit",
    "finance.documents": "Documents",
    "finance.integrations": "Integrations",
    "finance.accounting": "Accounting",
    "finance.ledger": "Grand livre",
    "finance.invoices": "Factures",
    "finance.payments": "Paiements",
    "finance.banking": "Banque",
    "finance.taxes": "Taxes",
    "finance.expenses": "Dépenses",
    "finance.assets": "Actifs",
    "finance.budgets": "Budgets",
    "finance.treasury": "Treasury",
    "finance.revenue": "Chiffre d’affaires",
    "finance.workflows": "Flux de travails",
    "finance.workflows.designer": "Designer",
    "finance.reports": "Rapports",
    "finance.reports.builder": "Concepteur",
    "finance.setup": "Configuration",
    "projects": "Projets",
    "projects.list": "Liste",
    "projects.tasks": "Tâches",
    "projects.boards": "Tableaux",
    "projects.sprints": "Sprints",
    "projects.timesheets": "Feuilles de temps",
    "projects.portfolio": "Portfolio",
    "projects.issues": "Tickets",
    "projects.gantt": "Gantt",
    "projects.resources": "Resources",
    "projects.calendar": "Calendrier",
    "projects.workload": "Charge de travail",
    "projects.reports": "Rapports",
    "projects.automation": "Automatisation",
    "projects.setup": "Configuration",
    "hr.org": "Rapportsing hierarchy",
    "pos.administration": "Gestion",
    "pos.profile": "Profil",
    "pos.organization": "Organisation",
    "pos.companies": "Sociétés",
    "pos.users": "Utilisateurs",
    "pos.roles": "Rôles",
    "pos.subscription": "Abonnement",
    "pos.settings": "Paramètres",
    "pos.work": "Travail",
    "pos.work.executive": "Direction",
    "pos.approvals": "Approbations",
    "pos.approvals.builder": "Concepteur",
    "pos.approvals.matrix": "Matrice",
    "pos.approvals.delegations": "Délégations",
    "pos.notifications": "Alertes",
    "crm.administration": "Gestion",
    "crm.profile": "Profil",
    "crm.organization": "Organisation",
    "crm.users": "Utilisateurs",
    "crm.roles": "Rôles",
    "crm.subscription": "Abonnement",
    "crm.settings": "Paramètres",
    "crm.work": "Travail",
    "crm.work.executive": "Direction",
    "crm.approvals": "Approbations",
    "crm.approvals.builder": "Concepteur",
    "crm.approvals.matrix": "Matrice",
    "crm.approvals.delegations": "Délégations",
    "crm.notifications": "Alertes",
    "hr.administration": "Gestion",
    "hr.profile": "Profil",
    "hr.organization": "Organisation",
    "hr.companies": "Sociétés",
    "hr.users": "Utilisateurs",
    "hr.roles": "Rôles",
    "hr.subscription": "Abonnement",
    "hr.settings": "Paramètres",
    "hr.work": "Travail",
    "hr.work.executive": "Direction",
    "hr.approvals": "Approbations",
    "hr.approvals.builder": "Concepteur",
    "hr.approvals.matrix": "Matrice",
    "hr.approvals.delegations": "Délégations",
    "hr.notifications": "Alertes",
    "desk.administration": "Gestion",
    "desk.profile": "Profil",
    "desk.organization": "Organisation",
    "desk.companies": "Sociétés",
    "desk.users": "Utilisateurs",
    "desk.roles": "Rôles",
    "desk.subscription": "Abonnement",
    "desk.settings": "Paramètres",
    "desk.work": "Travail",
    "desk.work.executive": "Direction",
    "desk.approvals": "Approbations",
    "desk.approvals.builder": "Concepteur",
    "desk.approvals.matrix": "Matrice",
    "desk.approvals.delegations": "Délégations",
    "desk.notifications": "Alertes",
    "finance.administration": "Gestion",
    "finance.profile": "Profil",
    "finance.organization": "Organisation",
    "finance.companies": "Sociétés",
    "finance.users": "Utilisateurs",
    "finance.roles": "Rôles",
    "finance.subscription": "Abonnement",
    "finance.settings": "Paramètres",
    "finance.work": "Travail",
    "finance.work.executive": "Direction",
    "finance.approvals": "Approbations",
    "finance.approvals.builder": "Concepteur",
    "finance.approvals.matrix": "Matrice",
    "finance.approvals.delegations": "Délégations",
    "finance.notifications": "Alertes",
    "projects.administration": "Gestion",
    "projects.profile": "Profil",
    "projects.organization": "Organisation",
    "projects.companies": "Sociétés",
    "projects.users": "Utilisateurs",
    "projects.roles": "Rôles",
    "projects.subscription": "Abonnement",
    "projects.settings": "Paramètres",
    "projects.work": "Travail",
    "projects.work.executive": "Direction",
    "projects.approvals": "Approbations",
    "projects.approvals.builder": "Concepteur",
    "projects.approvals.matrix": "Matrice",
    "projects.approvals.delegations": "Délégations",
    "projects.notifications": "Alertes",
    "procurement.administration": "Gestion",
    "procurement.profile": "Profil",
    "procurement.organization": "Organisation",
    "procurement.companies": "Sociétés",
    "procurement.users": "Utilisateurs",
    "procurement.roles": "Rôles",
    "procurement.subscription": "Abonnement",
    "procurement.settings": "Paramètres",
    "procurement.work": "Travail",
    "procurement.work.executive": "Direction",
    "procurement.approvals.builder": "Concepteur",
    "procurement.approvals.matrix": "Matrice",
    "procurement.approvals.delegations": "Délégations",
    "procurement.notifications": "Alertes",
    "warehouse.administration": "Gestion",
    "warehouse.profile": "Profil",
    "warehouse.organization": "Organisation",
    "warehouse.companies": "Sociétés",
    "warehouse.users": "Utilisateurs",
    "warehouse.roles": "Rôles",
    "warehouse.subscription": "Abonnement",
    "warehouse.settings": "Paramètres",
    "warehouse.work": "Travail",
    "warehouse.work.executive": "Direction",
    "warehouse.approvals": "Approbations",
    "warehouse.approvals.builder": "Concepteur",
    "warehouse.approvals.matrix": "Matrice",
    "warehouse.approvals.delegations": "Délégations",
    "warehouse.notifications": "Alertes",
    "social.administration": "Gestion",
    "social.profile": "Profil",
    "social.organization": "Organisation",
    "social.companies": "Sociétés",
    "social.users": "Utilisateurs",
    "social.roles": "Rôles",
    "social.subscription": "Abonnement",
    "social.work": "Travail",
    "social.work.executive": "Direction",
    "social.approvals.builder": "Concepteur",
    "social.approvals.matrix": "Matrice",
    "social.approvals.delegations": "Délégations",
    "social.notifications": "Alertes",
    "lead-gen.administration": "Gestion",
    "lead-gen.profile": "Profil",
    "lead-gen.organization": "Organisation",
    "lead-gen.companies": "Sociétés",
    "lead-gen.users": "Utilisateurs",
    "lead-gen.roles": "Rôles",
    "lead-gen.subscription": "Abonnement",
    "lead-gen.settings": "Paramètres",
    "lead-gen.work": "Travail",
    "lead-gen.work.executive": "Direction",
    "lead-gen.approvals": "Approbations",
    "lead-gen.approvals.builder": "Concepteur",
    "lead-gen.approvals.matrix": "Matrice",
    "lead-gen.approvals.delegations": "Délégations",
    "lead-gen.notifications": "Alertes",
    "marketing.administration": "Gestion",
    "marketing.profile": "Profil",
    "marketing.organization": "Organisation",
    "marketing.companies": "Sociétés",
    "marketing.users": "Utilisateurs",
    "marketing.roles": "Rôles",
    "marketing.subscription": "Abonnement",
    "marketing.settings": "Paramètres",
    "marketing.work": "Travail",
    "marketing.work.executive": "Direction",
    "marketing.approvals": "Approbations",
    "marketing.approvals.builder": "Concepteur",
    "marketing.approvals.matrix": "Matrice",
    "marketing.approvals.delegations": "Délégations",
    "marketing.notifications": "Alertes",
    "desk.customers": "Clients",
    "marketing.customers": "Clients",
    "projects.customers": "Clients",
    "lead-gen.customers": "Clients",
    "crm.customers": "Clients",
    "procurement.suppliers": "Fournisseurs",
    "procurement.products": "Produits",
    "procurement.inventory": "Inventaire",
    "procurement.inventory.ledger": "Grand livre",
    "settings": "Paramètres",
    "settings.organization": "Organisation",
    "settings.organization.organization-profile": "Organization Profile",
    "settings.organization.companies": "Sociétés",
    "settings.organization.users": "Utilisateurs",
    "settings.organization.roles": "Rôles et Screen Access",
    "settings.organization.subscription": "Abonnement",
    "settings.organization.stores": "Magasins",
    "settings.organization.translations": "Translations",
    "marketing.channels": "Canaux",
    "marketing.calendar": "Calendrier",
    "marketing.acquisition": "Acquisition",
    "marketing.media": "Médias",
    "marketing.copilot": "Copilot",
    "marketing.suppression": "Suppression",
    "social.messenger": "Messenger",
    "social.workflows": "Flux de travails",
    "social.connect.add": "Ajouter",
    "social.setup-guide": "Configuration Guide",
    "social.executive": "Direction",
    "social.platforms.facebook": "Facebook",
    "social.platforms.instagram": "Instagram",
    "social.platforms.whatsapp": "Whatsapp",
    "social.platforms.linkedin": "Linkedin",
    "social.platforms.x": "X",
    "social.platforms.youtube": "Youtube",
    "social.platforms.google_business": "Google_business",
    "social.platforms.telegram": "Telegram",
    "social.platforms.threads": "TRHeads",
    "social.platforms.pinterest": "Pinterest",
    "social.platforms.tiktok": "Tiktok",
    "projects.:id": ":id",
    "pos.employees": "Employés",
    "crm.employees": "Employés",
    "desk.employees": "Employés",
    "finance.employees": "Employés",
    "projects.employees": "Employés",
    "procurement.employees": "Employés",
    "warehouse.employees": "Employés",
    "social.employees": "Employés",
    "lead-gen.employees": "Employés",
    "marketing.employees": "Employés",
    "settings.hr-master-data": "RH Données de référence",
    "settings.hr": "Ressources humaines",
    "settings.finance": "Finances",
    "settings.inventory": "Inventaire et PDV",
    "settings.crm": "Ventes et CRM",
    "settings.marketing": "Marketing",
    "settings.projects": "Projets",
    "settings.help-desk": "Help Service client",
    "settings.communication": "Communication",
    "settings.workflow": "Flux de travail",
    "settings.approvals": "Approbations",
    "settings.notifications": "Alertes",
    "settings.developer": "Developer",
    "settings.hr.hr-setup": "RH Configuration",
    "settings.hr.org-structure": "Rapportsing Hierarchy",
    "settings.hr.hr-admin": "RH Administration",
    "settings.finance.finance-control": "Administration Home",
    "settings.finance.health-center": "Health Center",
    "settings.finance.period-close": "Période Close",
    "settings.finance.automation-center": "Automation Center",
    "settings.finance.integration-health": "Intégration Health",
    "settings.finance.accounting-advanced": "Accounting (Advanced)",
    "settings.finance.finance-setup": "Finance Configuration",
    "settings.finance.taxes": "Tax Codes",
    "settings.finance.business-rules": "Business Règles",
    "settings.finance.ledger": "General Ledger",
    "settings.finance.audit": "Finance Audit Trail",
    "settings.finance.workflows": "Finance Flux de travails",
    "settings.inventory.products": "Produits",
    "settings.inventory.categories": "Catégories",
    "settings.inventory.brands": "Marques",
    "settings.inventory.units": "Unités",
    "settings.inventory.tax-rules": "Règles fiscales",
    "settings.inventory.store-products": "Magasins Produits",
    "settings.inventory.discounts": "Remises",
    "settings.inventory.stock": "Stock Paramètres",
    "settings.inventory.stock-ledger": "Stock Ledger",
    "settings.inventory.warehouses": "Entrepôts",
    "settings.crm.crm-setup": "CRM Configuration",
    "settings.crm.lead-sources": "Prospect Sources",
    "settings.crm.contacts": "Contacts",
    "settings.crm.crm-companies": "CRM Sociétés",
    "settings.crm.customers": "Clients",
    "settings.marketing.templates": "Marketing Templates",
    "settings.marketing.segments": "Audience Segments",
    "settings.marketing.suppression": "Consent et Suppression",
    "settings.marketing.webhooks": "Marketing Webhooks",
    "settings.marketing.acquisition": "Forms et Landing Pages",
    "settings.projects.project-setup": "Projets Configuration",
    "settings.projects.boards": "Tableaux",
    "settings.projects.issues": "Tickets",
    "settings.projects.resources": "Resources",
    "settings.projects.automation": "Projets Automation",
    "settings.help-desk.desk-setup": "Service client Configuration",
    "settings.help-desk.workflows": "Service client Flux de travails",
    "settings.help-desk.canned-responses": "Réponses prédéfinies",
    "settings.help-desk.knowledge-base": "Knowledge Base",
    "settings.help-desk.boards": "Service client Boards",
    "settings.communication.social-connect": "Centre de connexion",
    "settings.communication.social-settings": "Social Paramètres",
    "settings.communication.social-webhooks": "Social Webhooks",
    "settings.workflow.finance-workflows": "Finance Flux de travail Concepteur",
    "settings.workflow.desk-workflows": "Service client Flux de travail Concepteur",
    "settings.workflow.project-automation": "Projets Flux de travail Automation",
    "settings.approvals.approval-builder": "Approbation Concepteur",
    "settings.approvals.approval-matrix": "Approbation Matrix",
    "settings.approvals.delegations": "Approbation Délégations",
    "settings.notifications.notification-center": "Notifications Center",
    "settings.developer.api-keys": "API Keys",
    "settings.developer.lead-webhooks": "Prospect Webhooks",
    "settings.developer.marketing-webhooks": "Marketing Webhooks",
    "settings.hr-master-data.leave-types": "Congés types",
    "settings.hr-master-data.employment-types": "Emploi types",
    "settings.hr-master-data.document-types": "Documents types",
    "settings.hr-master-data.business-units": "Business units",
    "settings.hr-master-data.departments": "Départements",
    "settings.hr-master-data.grades": "Grades",
    "settings.hr-master-data.designations": "Fonctions",
    "settings.hr-master-data.overtime-types": "Heures supplémentaires types",
    "settings.hr-master-data.shift-types": "Équipes types",
    "settings.hr-master-data.shift-definitions": "Équipes definitions",
    "settings.hr-master-data.expense-types": "Dépenses types",
    "settings.hr-master-data.asset-types": "Actif types",
    "settings.hr-master-data.asset-requests": "Demandes d'actifs",
    "settings.hr-master-data.pipeline-stages": "Pipeline stages",
    "settings.hr-master-data.holiday-calendar": "Holiday Calendrier",
    "settings.hr-master-data.holiday-types": "Types de jours fériés",
    "settings.hr-master-data.biometric-devices": "Appareils biométriques"
  },
  "modules": {
    "POS": "Point de vente",
    "HR": "Ressources humaines",
    "FINANCE": "Finances",
    "CRM": "CRM",
    "DESK": "Service client",
    "PROCUREMENT": "Achats",
    "WAREHOUSE": "Entrepôt",
    "PROJECTS": "Projets",
    "SOCIAL": "Social Media",
    "MARKETING": "Marketing",
    "LEADGEN": "Génération de leads"
  },
  "breadcrumbModules": {
    "POS": "PDV",
    "CRM": "CRM",
    "HR": "RH",
    "FINANCE": "Finances",
    "DESK": "Service client",
    "PROJECTS": "Projets",
    "PROCUREMENT": "Achats",
    "WAREHOUSE": "Entrepôt",
    "SOCIAL": "Social",
    "MARKETING": "Marketing",
    "LEADGEN": "Génération de leads"
  },
  "work": {
    "myWork": "Mon travail",
    "notifications": "Alertes",
    "approvalInbox": "Boîte d'approbation",
    "executiveView": "Vue exécutive",
    "approvalWorkflows": "Flux d'approbation",
    "workflowBuilder": "Concepteur de flux",
    "approvalMatrix": "Matrice d'approbation",
    "delegations": "Délégations d'approbation"
  },
  "sidebar": {
    "favorites": "Favoris",
    "recent": "Récents",
    "organization": "Organisation"
  }
}
